import { schema } from "normalizr"
import createdBy from "../../users/item"

export default new schema.Entity("customers", { createdBy }, { idAttribute: "customerId" })
